var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1662_51783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.604 9.40137C15.6705 9.44634 16.7395 9.46 17.8052 9.48409C18.0576 9.48971 18.3175 9.49774 18.5477 9.59894C19.2311 9.90011 19.3075 10.802 19.2821 11.5337C19.2533 12.3569 19.1398 13.3247 18.4071 13.7319C18.0256 13.9447 17.5626 13.9447 17.1235 13.9391L3.44536 13.772C2.93964 13.7656 2.52603 14.1631 2.52438 14.6563L2.49231 21.5487C2.48985 22.0097 2.52027 22.5398 2.8936 22.8217C3.13371 23.0032 3.45687 23.0313 3.7603 23.0506C8.03627 23.3253 12.327 23.3742 16.6079 23.1976C17.2411 23.1719 17.9738 23.0875 18.3142 22.5647C18.5362 22.2234 18.5206 21.7897 18.4976 21.3857C18.3825 19.3883 18.2673 18.2928 18.1522 16.2954",
    stroke: "#30426D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2998 7.54004C7.44527 8.15925 8.71079 8.59455 9.98865 8.87324C11.5041 9.20333 13.0501 9.33584 14.6034 9.4017",
    stroke: "#30426D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73585 2.83188C8.49171 1.991 7.11107 1.34207 5.66053 0.921225C4.91388 0.704379 4.07349 0.555799 3.38358 0.909177C2.65914 1.28022 2.29815 2.14279 2.35735 2.9403C2.41656 3.73701 2.82935 4.47187 3.32849 5.10474C4.12776 6.11749 5.154 6.92062 6.29946 7.53984",
    stroke: "#30426D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9068 6.57882C12.8394 6.24712 12.7209 5.92266 12.5639 5.62229C12.1774 4.88581 11.5755 4.27704 10.9333 3.73653C10.5509 3.41448 10.1513 3.1133 9.73682 2.83301",
    stroke: "#30426D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82798 6.19629C9.48262 6.57938 9.2055 7.01388 9.14054 7.51262C9.01144 8.5061 9.93324 9.50198 10.9586 9.47548C11.8064 9.4538 12.558 8.80968 12.831 8.02583C12.993 7.56081 13.0045 7.06126 12.9075 6.57858",
    stroke: "#30426D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.985116 11.7653C0.847792 11.3549 0.708001 10.9357 0.714579 10.5044C0.721157 10.0731 0.900419 9.61933 1.27457 9.38964C1.59609 9.19287 1.99901 9.18966 2.37892 9.19367C3.90593 9.20813 5.43212 9.22259 6.95913 9.23704C8.20409 9.24909 9.29775 8.99691 10.523 8.80094C13.7505 8.28453 17.0578 6.93526 18.7583 4.16847C18.9055 3.92834 18.9746 3.64483 18.9277 3.36855C18.7822 2.51402 17.7716 2.44174 17.0002 2.5606C14.5046 2.9453 12.1339 4.07049 10.2812 5.74904C10.125 5.89039 9.97122 6.03977 9.82814 6.19799",
    stroke: "#30426D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1662_51783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.cf0c2372ba2414c14f821db0c028f4e3.svg";
export { ForwardRef as ReactComponent };